import React from "react";
import {Link} from 'react-router-dom'

const TcUnfollowmain = () => {
return(
    <>
 
        <div className='TC-addmain'>   
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Unfollow </span>
    </div>
    </div>
    </div>

    </>
)
}

export default TcUnfollowmain;